import React from 'react';
import { connect } from 'react-redux';
import { ValidMe } from '../../../../businessLogic/validation.js';
import Txt from '../../../inputs/textInput.js';
import Lbl from '../../../inputs/label.js';
import objectAssign from 'object-assign';
import { updateMeetingRoomForm } from '../../../../actions/meetingRoom.js';
import { clone } from '../../../../reducers/helper.js';

@connect(mapStateToProps)
export default class CenterPanelCreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groups: props.groups,
      meetingRoomForm: props.meetingRoomForm,
    };
    this.groupSelectedChanged = this.groupSelectedChanged.bind(this);
    this.meetingRoomNameChanged = this.meetingRoomNameChanged.bind(this);
    this.meetingRoomUpdated = this.meetingRoomUpdated.bind(this);
  }

  meetingRoomUpdated(property, value) {
    let val = value;
    var cloneMeetingRoom = clone(this.state.meetingRoomForm);
    property.map((option, i) => {
      cloneMeetingRoom[option] = value[i];
    }, this);
    return cloneMeetingRoom;
  }

  groupSelectedChanged(option) {
    if (option) {
      if (option.name) {
        var parentGroupName = option.name + ' (' + option.orgAbbreviatedName + ')';
        this.props.dispatch(
          updateMeetingRoomForm(
            this.meetingRoomUpdated(['parentGroupName', 'parentGroupId'], [parentGroupName, option.id])
          )
        );
      }
    }
    // this.props.dispatch(updateMeetingRoomForm(this.meetingRoomUpdated2("parentGroupName",option)));
  }
  meetingRoomNameChanged(value) {
    this.props.dispatch(updateMeetingRoomForm(this.meetingRoomUpdated(['name'], [value])));
  }
  UNSAFE_componentWillReceiveProps(props) {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA
    this.setState({
      groups: props.groups,
      meetingRoomForm: props.meetingRoomForm,
    });
  }
  render() {
    var groups = '';

    return (
      <div className="ui form">
        <ValidMe
          validmefor="length@3-64"
          validmemessage={APP.LANGUAGE.Errors.MeetingRoomValidNameLength}
          group="createMeetingRoomForm"
        >
          <Txt
            tabIndex="1"
            focusme="true"
            value={this.state.meetingRoomForm.name}
            placeholder={APP.LANGUAGE.CreateUpdateMeetingRoom.NamePlaceholder}
            noTitle
            onChange={this.meetingRoomNameChanged}
          />
        </ValidMe>

        <ValidMe
          validmefor="dropdown"
          group="createMeetingRoomForm"
          defaulttext={APP.LANGUAGE.CreateUpdateMeetingRoom.GroupPlaceHolder}
          validmemessage={APP.LANGUAGE.Errors.CreateMeetingRoomNonSelectedGroupError}
        >
          <Txt
            visible={!this.props.meetingRoomForm.headerName}
            dropdown
            tabIndex="2"
            selectedItemPlaceholder={APP.LANGUAGE.CreateUpdateMeetingRoom.SelectedGroupPlaceHolder}
            placeholder={APP.LANGUAGE.CreateUpdateMeetingRoom.GroupPlaceHolder}
            text={APP.LANGUAGE.CreateUpdateMeetingRoom.GroupPlaceHolder}
            value={this.state.meetingRoomForm.parentGroupName}
            fields={'name,orgAbbreviatedName'}
            options={this.state.groups}
            onChange={this.groupSelectedChanged}
          />
        </ValidMe>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    groups: state.groupsReducer.meetingRoomGroups,
    meetingRoomForm: state.meetingRoomReducer.meetingRoomForm,
  };
}
